import { useQueryClient } from "@tanstack/react-query";

export function useCachedAuthProfile() {
  const qc = useQueryClient();
  return qc.getQueryData<{
    firstName?: string;
    lastName?: string;
    avatarUrl?: string;
  }>(["auth", "currentUser"]);
}
